import '../styles/game.css';

interface RoundProgressDotsProps {
  currentRound: number;
  totalRounds: number;
}

export default function RoundProgressDots({
  currentRound,
  totalRounds,
}: Readonly<RoundProgressDotsProps>) {
  return (
    <div className="puzzle-round-dots" aria-label="Round progress">
      {Array.from({ length: totalRounds }, (_, i) => {
        const roundNum = i + 1;
        const isDone = roundNum < currentRound;
        const isCurrent = roundNum === currentRound;

        let modifier = '';
        if (isDone) modifier = 'puzzle-round-dot--done';
        else if (isCurrent) modifier = 'puzzle-round-dot--current';

        return (
          <span key={roundNum} className={`puzzle-round-dot${modifier ? ` ${modifier}` : ''}`} />
        );
      })}
    </div>
  );
}
